import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Wallet from "../pages/wallet/page";
import Transactions from "../pages/transactions/page";
import AdminDashboard from "../pages/admin/page";
import Auth from "../pages/auth/page";
import PaymentSuccess from "../pages/trade/components/PaymentSuccess";
import BuyCrypto from "../pages/buy/page";
import SellCrypto from "../pages/sell/page";
import WithdrawCrypto from "../pages/withdraw-crypto/page";
import WithdrawNaira from "../pages/withdraw-naira/page";
import Profile from "../pages/profile/page";
import OnboardingGuard from "../components/OnboardingGuard";
import Onboarding from "../pages/onboarding/page";
import BuyCallback from "../pages/buy/BuyCallback";
import SellCallback from "../pages/sell/SellCallback";
import TransactionDetail from "../pages/transactions/TransactionDetail";
import KYCPage from "../pages/kyc/page";
import SupportPage from "../pages/support/page";
import BillsPage from "../pages/bills/BillsPage";
import AirtimePage from "../pages/bills/AirtimePage";
import DataPage from "../pages/bills/DataPage";
import ElectricityPage from "../pages/bills/ElectricityPage";
import TVPage from "../pages/bills/TVPage";
import BillConfirmPage from "../pages/bills/BillConfirmPage";
import BillSuccessPage from "../pages/bills/BillSuccessPage";
import FiatDeposit from "../pages/deposit/FiatDeposit";
import GoogleCallback from "../pages/auth/GoogleCallback";
import TermsPrivacy from "../pages/termsPrivacy/page";
import ResetPasswordPage from "../pages/auth/ResetPasswordPage";
import RewardsPage from "../pages/reward/page";
import DepositPage from "../pages/deposit/page";
import DepositCrypto from "../pages/deposit/DepositCrypto";
import DepositVerify from "../pages/deposit/DepositVerify";

const routes = [
    {
    element: <OnboardingGuard />,
    children: [
  { path: "/", element: <Home />},
  { path: "/home", element: <Home />},
  { path: "/buy", element: <BuyCrypto /> },
  {path: "/buy-crypto", element: <BuyCallback /> },
  {path: "/sell-crypto", element: <SellCallback /> },
  { path: "/sell", element: <SellCrypto /> },
  { path: "/deposit", element: <DepositPage /> },
  { path: "/deposit-fiat", element: <FiatDeposit /> },
  { path: "/deposit-fiat/verify", element: <DepositVerify /> },
  { path: "/deposit-crypto", element: <DepositCrypto /> },
  { path: "/withdraw-crypto", element: <WithdrawCrypto /> },
  { path: "/withdraw-naira", element: <WithdrawNaira /> },
  { path: "/transactions", element: <Transactions /> },
  { path: "/transaction/:id", element: <TransactionDetail /> },
  { path: "/wallet", element: <Wallet /> },

  { path: "/bills", element: <BillsPage /> },
  { path: "/bills/airtime", element: <AirtimePage /> },
  { path: "/bills/data", element: <DataPage /> },
  { path: "/bills/electricity", element: <ElectricityPage /> },
  { path: "/bills/tv", element: <TVPage /> },
  { path: "/bills/confirm", element: <BillConfirmPage /> },
  { path: "/bills/success", element: <BillSuccessPage /> },


  { path: "/reward", element: <RewardsPage />},
  { path: "/kyc", element: <KYCPage /> },
  { path: "/support", element: <SupportPage /> },
  { path: "/terms-privacy", element: <TermsPrivacy /> },
  { path: "/profile", element: <Profile /> },
  { path: "/payment/success", element: <PaymentSuccess />},

  { path: "/admin", element: <AdminDashboard />},
  { path: "/auth", element: <Auth />},
  { path: "/reset-password", element: <ResetPasswordPage />},
  { path: "/auth/google/success", element: <GoogleCallback />},
   ],
  },
  {
    path: "/onboarding",
    element: <Onboarding />,
  },

  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
